const divForgotPassConfirm = {
text: 'Senha alterada com sucesso'
};

export default divForgotPassConfirm;
